<template>
  <section class="edit-policy-form width-700">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <working-policy-form
        ref="policy-form"
        :form="form"
        :isRequired="isRequired"
        :editType="editType"
        :showBuyable="showBuyable"
        :isRefer="isRefer"
        :checkRefer="checkRefer"
        @getFormData="getFormData" />
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import WorkingPolicyForm from '@/views/quoting/modules/working/form/working-policy-form'
import MixinSame from '@/mixins/same'

export default {
  name: 'editWorkingPolicyForm',
  components: {
    WorkingPolicyForm
  },
  mixins: [MixinOptions, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        benefits: []
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions26
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
      }
    },
    // editType: {
    //   immediate: true,
    //   handler(val) {
    //     this.requireValid = val === 2? true: false
    //   }
    // },
  },
  methods: {
    submitForm(otherData = {}) {
      this.$refs['form'].validate(valid => {
        if(valid) {
          this.$refs['policy-form'].submitForm(otherData)
        }
      })

    },
    getFormData(data, otherData) {
      // 整合其他數據
      const result = {
        ...data,
        ...this.formData
      }
      this.$emit('getFormData', result, otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-policy-form {
  // width: 700px;
}
</style>
